import { useState,useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AddVendor({
  setOpenAddVendor,
  supplierDetailResponse,
  tokenStorage,
  onSubmit,
  setOpenAddProfile,
}) {
  const [mailPresent, setMailPresent] = useState(false);
  const[vendorCategory,setVendorCategory]=useState([])
  const [formData, setFormData] = useState({
    VendorFirstName: "",
    VendorLastName: "",
    VendorEmail: "",
    VendorCategory:"",
    CreatedBy: "Admin",
    ModifiedBy: "null",
  });
  const [isEmailValid, setIsEmailValid] = useState("");

  const baseAPI = process.env.REACT_APP_API_URL;

  useEffect(() => {
      GetVendorCategory()
  }, []);

  function GetVendorCategory(){
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}AdminGet/GetVendorCategory`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setVendorCategory(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "VendorEmail") {
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      setIsEmailValid(isValidEmail);
    }

    setFormData({
      ...formData,
      [name]: value,
    });
  };


  function CheckMailPresence() {
    let emailPresent = false;
    supplierDetailResponse.forEach((obj) => {
      if (obj.VendorEmail === formData.VendorEmail) {
        emailPresent = true;
      }
    });
    setMailPresent(emailPresent);
    return emailPresent;
  }

  const handleSubmit = async (e) => {
    const isEmailPresent = CheckMailPresence();
    e.preventDefault();
    if (isEmailPresent) {
      alert(`formData.VendorEmail} Is Already Added`)
      return;
    }
    for (const key in formData) {
      if (formData[key] === "") {
        alert("All fields are mandatory. Please fill out all fields.");
        return;
      }
    }
    if (formData.VendorEmail !== "" && isEmailValid != "") {
      try {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        const response = await axios.post(
          `${baseAPI}Adminpost/AddVendor`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );

      } catch (error) {
        console.error("Error posting data:", error);
      }
      setFormData({
        VendorFirstName: "",
        VendorLastName: "",
        VendorEmail: "",
        CreatedBy: "Admin",
      });
      tokenStorage();
      alert(`Vendor Added Successfully`)
      setOpenAddVendor(false)
    } else {
   alert(`Email Address is not valid`)
    }
  };

  const resetForm=()=>{
    setFormData({
      VendorFirstName: "",
      VendorLastName: "",
      VendorEmail: "",
      VendorCategory:"",
      CreatedBy: "Admin",
    });
  }

  return (
    <div style={{border:"2px solid #C0C6CC",marginBottom:"20px"}}  className="container-fluid">

      <div className="vendorDetail" style={{marginBottom:"18px"}}>
        <div className="vendor-form">
          <table style={{ width: "100%",marginBottom:"70px" }} className="addvendorTable">
            <tr
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
              className="tableHeading tableHeading2"
            >
  <td
                style={{
                  color: "#6a6a6a",
                  fontWeight: "bold",
                  width: "100%",
                  marginTop: "13px",
                }}
              >First Name</td>
  <td
                style={{
                  color: "#6a6a6a",
                  fontWeight: "bold",
                  width: "100%",
                  marginTop: "13px",
                }}
              >Last Name</td>
              <td
                style={{
                  color: "#6a6a6a",
                  fontWeight: "bold",
                  width: "100%",
                  marginTop: "13px",
                }}
              >Email</td>
  <td
                style={{
                  color: "#6a6a6a",
                  fontWeight: "bold",
                  width: "100%",
                  marginTop: "13px",
                }}
              >Category</td>
</tr>
<tr
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
              className="tableHeading tableHeading2"
            >
  <td
                style={{
                  color: "#6a6a6a",
                  fontWeight: "bold",
                  width: "100%",
                  marginTop: "13px",
                }}
              >
                  <input
                  type="text"
                  style={{
                    border: "1px solid #5b489d",
                    width: "100%",
                    padding: "12px",
                    borderRadius: "6px",
                    marginBottom: "21px",
                    marginTop: "25px",
                    height: "45px",
                    color: "#6a6a6a",
                    position: "relative",
                    padding: "12px",
                  }}
                  name="VendorFirstName"
                  value={formData.VendorFirstName}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                />
              </td>
  <td
                style={{
                  color: "#6a6a6a",
                  fontWeight: "bold",
                  width: "100%",
                  marginTop: "13px",
                }}
              >
                  <input
                  type="text"
                  style={{
                    border: "1px solid #5b489d",
                    width: "100%",
                    padding: "12px",
                    borderRadius: "6px",
                    marginBottom: "21px",
                    marginTop: "25px",
                    height: "45px",
                    color: "#6a6a6a",
                    position: "relative",
                    padding: "12px",
                  }}
                  name="VendorLastName"
                  value={formData.VendorLastName}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                />
              </td>
              <td
                style={{
                  color: "#6a6a6a",
                  fontWeight: "bold",
                  width: "100%",
                  marginTop: "13px",
                }}
              >  <input
              type="text"
              style={{
                border: "1px solid #5b489d",
                width: "100%",
                padding: "12px",
                borderRadius: "6px",
                marginBottom: "21px",
                marginTop: "25px",
                height: "45px",
                color: "#6a6a6a",
                position: "relative",
                padding: "12px",
              }}
              name="VendorEmail"
              value={formData.VendorEmail}
              placeholder="Please Enter*"
              onChange={handleChange}
              required
            /></td>
<td
                style={{
                  color: "#6a6a6a",
                  fontWeight: "bold",
                  width: "100%",
                  marginTop: "13px",
                }}
              >  
              <select   
              style={{
                border: "1px solid #5b489d",
                width: "100%",
                padding: "12px",
                borderRadius: "6px",
                marginBottom: "21px",
                marginTop: "25px",
                height: "45px",
                color: "#6a6a6a",
                position: "relative",
                padding: "12px",
                marginLeft:"0px"
              }}
              className="form-control"  
              name="VendorCategory"
              onChange={handleChange}
              required
              value={formData.VendorCategory}
            >
              <option value="0">Select an option</option>
                  {vendorCategory.map((item) => (
                    <option key={item.Tseed} value={item.Tseed}>
                    {item.Category_Name}
                  </option>
                  ))}
         </select> 
              </td>
</tr>

          </table>
          <br/>
          <hr />
          <div
            className="row px-3  text-end reset-addvendor-button"
          >
            <div className="col-12 px-0">
            <button
                className=""
                type=""
                onClick={resetForm}
                style={{
                  backgroundColor: "white",
                  color: "#F15348",
                  width: "139px",
                  border:"none"
                }}
              >
                Reset
              </button>
              <button
                className=""
                type="submit"
                onClick={handleSubmit}
                style={{
                  backgroundColor: "#5B489D",
                  color: "white",
                  width: "139px",
                }}
              >
                Add Vendor
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default AddVendor;
